module.exports = __webpack_public_path__ + "img/cascade_logo.3d01d331.jpg";